import React, { useState } from "react";
import t from "../../../localization/en/translation.json";
import "./announcement.scss";
import MoreMenu from "../../moreMenu/moreMenu";
import { MoreMenuOption } from "../../moreMenu/moreMenuOptions";
import { useSelector } from "react-redux";
import { APP_STATE } from "../../../store/reducers";
import moment from "moment";

interface AnnouncementProps {
  id: string;
  title: string;
  description: string;
  createdBy: string;
  createdDate: string;
  isImportant?: boolean;
  isProjectAdmin: boolean;
  authorId: string;
  deleteAnnouncement: Function;
  editAnnouncement: Function;
  status?: string;
  makeAnnouncementRead?: Function;
  modifiedDate?: string;
  modifiedByUserName?: string;
}

const Announcement: React.FC<AnnouncementProps> = ({ id, title, description, createdBy, createdDate, modifiedDate, modifiedByUserName, isImportant = false, isProjectAdmin = false, authorId, deleteAnnouncement, editAnnouncement, status, makeAnnouncementRead }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 100;
  const currentUser = useSelector((state: APP_STATE) => state.meReducer.currentUser);

  const options: MoreMenuOption[] = [
    {
      id: "123",
      actionName: t.edit,
      title: t.edit,
    },
    {
      id: "124",
      actionName: t.delete,
      title: t.delete,
    },
  ];
  const isAuthor = currentUser?.id === authorId;
  const filteredOptions = isAuthor || isProjectAdmin ? options : [];
  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const onActionStart = (actionName: string, id: string) => {
    if (actionName === t.delete) {
      deleteAnnouncement(true, id);
    } else if (actionName === t.edit) {
      editAnnouncement(true, id);
    }
  };

  const renderDescription = () => {
    if (description.length <= maxLength) {
      return <p className="card-description">{description}</p>;
    }

    return (
      <p className="card-description">
        {isExpanded ? description : `${description.substring(0, maxLength)}...`}
        <span onClick={toggleDescription} className="toggle-description">
          {isExpanded ? t.show_less : t.show_more}
        </span>
      </p>
    );
  };

  return (
    <div className={`render-card app-col-xs-12 app-col-lg-12 app-col-xl-12 ${status === 'UnRead' && 'unread-card'}`}>
      <div className="created-wrapper">
        <h4 className="createdBy">{createdBy}</h4>
        {(makeAnnouncementRead && status === 'UnRead') && <span onClick={()=> makeAnnouncementRead(id)}>{t.markAsRead}</span>}
      </div>
      <div className="card-header">
        <h2 className="card-title" title={title}>{title}</h2>
        <div className="card-right">
          {isImportant && <span className="critical-pill">{t.announcement_important_label}</span>}
          {filteredOptions.length > 0 && <MoreMenu controlId="more-menu-apps" optionClickFn={(action) => onActionStart(action, id)} options={filteredOptions} stopEventBubbling vertical={true} />}
        </div>
      </div>
      {renderDescription()}
      <div className="card-footer">
      <div className="updated-created">
          {modifiedDate && (
            <>
              <span className="tag-label">{t.announcement_updated_by}</span>
              <span className="tag-date">
              {modifiedByUserName}
              </span>
            </>
          )}
        </div>
        <div className="updated-created align-text-right">
          {modifiedDate ? (
            <>
              <span className="tag-label">{t.announcement_updated_on}</span>
              <span className="tag-date">
                {moment.utc(modifiedDate).format('MMM DD, yyyy')}
              </span>
            </>
          ) : (
            <>
              <span className="tag-label">
                {t.edit_project_announcement_created_on}
              </span>
              <span className="tag-date">
                {moment.utc(createdDate).format('MMM DD, yyyy')}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Announcement;
